import { defineComponent, computed } from '@vue/composition-api';
import __vue_component__ from '../SdsSkeleton/SdsSkeleton.vue.js';
import { useThemedLogo } from '../theme/useThemedLogo.js';

var Brand = {
    Superbet: 'superbet',
    Napoleon: 'napoleon',
    SuperSocial: 'supersocial',
};
var supportedBrands = Object.values(Brand);
var script = defineComponent({
    props: {
        brand: {
            type: String,
            required: true,
        },
        destination: {
            type: Object,
            required: true,
        },
    },
    setup: function (props) {
        // remote 'uplifted' from the logo name once design uplift release is over
        // using a separate flag only because `useThemedLogo` doesn't support sending empty values and it requires a ref to be passed into it
        var shouldShowLogo = computed(function () { return supportedBrands.includes(props.brand); });
        var altLogoUrl = useThemedLogo(computed(function () { return "brand-".concat(props.brand); }));
        return {
            shouldShowLogo: shouldShowLogo,
            altLogoUrl: altLogoUrl,
        };
    },
    components: {
        SdsSkeleton: __vue_component__,
    },
});

export default script;
